import React from "react";
import { Route } from "react-router-dom";
import { Flex, Box } from "grid-styled";
import { Table, TableRow, TableCell } from "./Table";
import Moment from "react-moment";
import Link from "./Link";
import { LinkButton } from "./Button";
import TransmittalTemplateEditor from "./TransmittalTemplateEditor";
import join from "../utils/join-path";
import { getTransmittalTemplates } from "../api";
import CenteredLoader from "./CenteredLoader";

class TransmittalTemplates extends React.Component {
  state = {
    loading: false,
    templates: []
  };

  componentDidMount() {
    this.loadTemplates();
  }

  loadTemplates = () => {
    this.setState({ loading: true });

    return getTransmittalTemplates()
      .then(templates => {
        this.setState({ templates, loading: false });
      })
      .catch(err => console.log("Could not fetch transmittal templates", err));
  };

  renderTemplate = template => (
    <TableRow key={template.id}>
      <TableCell>
        <Link
          to={join(this.props.match.url, `/${template.id}`)}
          style={{ fontWeight: 600 }}
        >
          {template.name}
        </Link>
      </TableCell>
      <TableCell>
        <Moment format="MMM D, YYYY [at] h:mm a">{template.updated_at}</Moment>
      </TableCell>
    </TableRow>
  );

  closeEditor = () => {
    this.loadTemplates();
    this.props.history.push(this.props.match.url);
  };

  render() {
    const { loading, templates } = this.state;

    if (loading) return <CenteredLoader />;

    return (
      <Box p={3}>
        <Flex pb={2} justify="flex-end">
          <LinkButton to={join(this.props.match.url, "/new")} variant="primary">
            New template
          </LinkButton>
        </Flex>
        {templates.length ? (
          <Table noSideBorders>
            <TableRow header>
              <TableCell>Name</TableCell>
              <TableCell>Last Updated At</TableCell>
            </TableRow>
            {templates.map(this.renderTemplate)}
          </Table>
        ) : (
          "No transmittal templates yet."
        )}
        <Route
          path={`${this.props.match.path}/:templateId`}
          render={routeProps => (
            <TransmittalTemplateEditor
              {...routeProps}
              close={this.closeEditor}
            />
          )}
        />
      </Box>
    );
  }
}

export default TransmittalTemplates;



// WEBPACK FOOTER //
// ./src/components/TransmittalTemplates.js